module.exports = __webpack_public_path__ + "assets/images/template/sample-logo.svg?v=a3144429";